<template>

</template>

<script>
import commonstate from '@/js/constant.js';
export default {//用于跳转到登录页
    mounted() {
          window.location.href=commonstate.frontEndUrl + "";
    },
    methods: {

    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/turn_login_page.vue